import { useRegisterContext } from "../../Contexts/RegisterContext";
import Button from "../../Components/Button";

function CardSuccess() {
  const { navigate } = useRegisterContext();

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen sm:bg-[#E7EEFA] cursor-default">
      <div className="bg-white w-screen sm:mt-24 sm:w-148 h-72 rounded-xl sm:justify-center">
        <div className="mt-52 sm:mt-0 flex flex-col items-center justify-center text-center px-6">
          <div className="flex justify-center mt-3">
            <img
              src={require("../../assets/success.png")}
              alt="Personal"
              className="w-24 h-24 flex justify-center"
            />
          </div>
          <div className="text-2xl text-center font-semibold">
            Details Sent Successfully
          </div>

          <div className=" text-center mx-3 text-[#60656D]">
            Details sent! Your healthcare information has been successfully
            submitted. Keep an eye on your email for confirmation and further
            instructions. Thank you for entrusting us with your health
          </div>
        </div>

        <div className="flex sm:flex-row flex-col items-center sm:w-full justify-center absolute p-2 inset-x-0 bottom-0 sm:relative sm:px-8">
          <Button
            className="w-full h-12 text-white rounded-xl font-semibold transition ease-in-out delay-75 hover:scale-105"
            onClick={() => navigate("/home")}
          >
            Go to dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CardSuccess;
